<template>
  <div class="order-payment-page app-page">

    <el-card v-loading="loading" class="payment-card" shadow="never">
      <!-- 错误提示 -->
      <div v-if="error" class="error-message">{{ error }}</div>

      <div v-if="orderInfo && !loading" class="payment-content">
        <div class="payment-layout">
          <!-- 订单信息 -->
          <div class="order-summary">
            <div class="summary-header">
              <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="3" width="20" height="14" rx="2" ry="2"/><line x1="8" y1="21" x2="16" y2="21"/><line x1="12" y1="17" x2="12" y2="21"/></svg>
              <h2 class="section-title">订单信息</h2>
            </div>
            <div class="order-details">
              <div class="detail-row">
                <span class="label">订单编号</span>
                <span class="value mono">{{ orderInfo.orderSn }}</span>
              </div>
              <div class="detail-divider"></div>
              <div class="detail-row pay-amount">
                <span class="label">支付金额</span>
                <span class="value price">¥{{ orderInfo.totalAmount.toFixed(2) }}</span>
              </div>
            </div>
          </div>

          <!-- 支付方式 -->
          <div class="payment-methods">
            <div class="summary-header">
              <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="4" width="22" height="16" rx="2" ry="2"/><line x1="1" y1="10" x2="23" y2="10"/></svg>
              <h2 class="section-title">选择支付方式</h2>
            </div>
            <div class="method-options">
              <div class="method-item" :class="{ selected: payType === 'alipay' }" @click="payType = 'alipay'">
                <div class="method-left">
                  <div class="method-icon alipay">
                    <svg viewBox="0 0 24 24" width="22" height="22" fill="currentColor"><path d="M21.422 15.358c-3.22-1.386-6.847-2.408-10.276-3.127 1.68-3.54 3.413-7.215 4.697-11.09H9.673c-1.32 3.305-3.067 7.21-4.98 10.495 1.636.585 3.203 1.264 4.71 2.016 1.83-3.285 3.597-6.58 4.75-9.23.524 1.578.916 3.214 1.354 4.79.868 2.888 1.85 5.627 3.035 8.105-.023.004-.046.004-.07.005a2.766 2.766 0 00-.304-.05c-1.607-.21-3.03-.737-4.48-1.895-2.08 2.183-4.494 4.09-7.344 5.243-1.84.745-4.427 1.19-6.375.225-.942-.467-1.425-1.305-1.274-2.522.093-.755.48-1.394.973-1.855 2.448-2.287 5.532-3.42 8.817-4.215-1.444-1.523-2.838-3.134-3.97-4.937-1.263-2.015-1.968-4.644-1.445-7.602.144-.812.58-1.365 1.386-1.568.413-.105.94-.025 1.358.088 5.11 1.206 7.296 4.637 8.698 9.088.096.305.073.242.227.068.26-.29.628-.363 1.01-.534 1.338-.597 2.722-1.11 4.083-1.63.34-.13.688-.232 1.028-.366v-2.9c0-1.927 0-2.89-.652-3.615-.653-.724-1.68-.724-3.738-.724H6.256c-2.058 0-3.087 0-3.738.724-.652.724-.652 1.688-.652 3.615v7.77c0 1.927 0 2.89.652 3.615.651.724 1.68.724 3.738.724h11.488c2.058 0 3.087 0 3.738-.724.328-.364.484-.897.566-1.677.03-.284.036-.586.046-.912.037-1.217-.622-1.57-1.422-1.958z"/></svg>
                  </div>
                  <div class="method-info">
                    <h3>支付宝</h3>
                    <p>推荐使用支付宝扫码支付</p>
                  </div>
                </div>
                <div class="method-selector" :class="{ selected: payType === 'alipay' }">
                  <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                </div>
              </div>
              <div class="method-item" :class="{ selected: payType === 'wechat' }" @click="payType = 'wechat'">
                <div class="method-left">
                  <div class="method-icon wechat">
                    <svg viewBox="0 0 24 24" width="22" height="22" fill="currentColor"><path d="M8.691 2.188C3.891 2.188 0 5.476 0 9.53c0 2.212 1.17 4.203 3.002 5.55a.59.59 0 01.213.665l-.39 1.48c-.019.07-.048.141-.048.213 0 .163.13.295.29.295a.326.326 0 00.167-.054l1.903-1.114a.864.864 0 01.717-.098 10.16 10.16 0 002.837.403c.276 0 .543-.027.811-.05-.857-2.578.157-4.972 1.932-6.446 1.703-1.415 3.882-1.98 5.853-1.838-.576-3.583-4.196-6.348-8.596-6.348zM5.785 5.991c.642 0 1.162.529 1.162 1.18a1.17 1.17 0 01-1.162 1.178A1.17 1.17 0 014.623 7.17c0-.651.52-1.18 1.162-1.18zm5.813 0c.642 0 1.162.529 1.162 1.18a1.17 1.17 0 01-1.162 1.178 1.17 1.17 0 01-1.162-1.178c0-.651.52-1.18 1.162-1.18zm5.34 2.867c-1.797-.052-3.746.512-5.28 1.786-1.72 1.428-2.687 3.72-1.78 6.22.942 2.453 3.666 4.229 6.884 4.229.826 0 1.622-.12 2.361-.336a.722.722 0 01.598.082l1.584.926a.272.272 0 00.14.045c.134 0 .24-.11.24-.245 0-.06-.024-.12-.04-.178l-.325-1.233a.492.492 0 01.178-.553C23.028 18.333 24 16.592 24 14.628c0-3.299-3.063-5.77-7.062-5.77zm-2.18 2.453c.535 0 .969.44.969.982a.976.976 0 01-.969.983.976.976 0 01-.969-.983c0-.542.434-.982.97-.982zm4.36 0c.535 0 .969.44.969.982a.976.976 0 01-.969.983.976.976 0 01-.969-.983c0-.542.434-.982.97-.982z"/></svg>
                  </div>
                  <div class="method-info">
                    <h3>微信支付</h3>
                    <p>推荐使用微信扫码支付</p>
                  </div>
                </div>
                <div class="method-selector" :class="{ selected: payType === 'wechat' }">
                  <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 操作按钮 -->
        <div class="action-bar">
          <el-button class="cancel-btn" @click="handleBack">
            <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
            取消支付
          </el-button>
          <el-button type="primary" class="pay-btn" @click="handlePay" :disabled="!payType">
            <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
            确认支付 ¥{{ orderInfo.totalAmount.toFixed(2) }}
          </el-button>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script setup>
// ==================== 脚本逻辑 完全不变 ====================
import { ref, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { ElMessage, ElButton, ElCard } from 'element-plus'
import orderApi from '@/api/order'
import paymentApi from '@/api/payment'

const route = useRoute()
const router = useRouter()
const orderInfo = ref(null)
const loading = ref(true)
const error = ref('')
const payType = ref('alipay')

const fetchOrderInfo = async () => {
  const orderSn = route.params.orderSn
  if (!orderSn) {
    error.value = '订单编号不存在'
    loading.value = false
    return
  }

  try {
    const res = await orderApi.getOrderDetail(orderSn)
    orderInfo.value = res.data.data
  } catch (err) {
    error.value = '获取订单信息失败'
  } finally {
    loading.value = false
  }
}

const handlePay = async () => {
  if (!orderInfo.value) return

  const payTypeMap = { alipay: 2, wechat: 1 }
  const formData = {
    orderNo: route.params.orderSn,
    amount: Math.round(orderInfo.value.totalAmount * 100),
    payType: payTypeMap[payType.value],
    description: orderInfo.value.productName || '订单支付',
    notifyUrl: ''
  }

  try {
    const response = await paymentApi.createPayment(formData)
    if (response.data.code==200) {
      if(response.data.data.payType==2){
        ElMessage.success('正在跳转到支付页面...')
        router.push({ path: '/payment/redirect', query: { orderNo: route.params.orderSn } })
      }else{
        ElMessage.success('支付成功，正在跳转到订单详情页面...')
        router.push(`/order/detail/${route.params.orderSn}`)
      }
    } else {
      ElMessage.error(response.message || '创建支付订单失败')
    }
  } catch (err) {
    console.error('支付请求失败', err)
    ElMessage.error('支付请求失败，请重试')
  }
}

// 返回上一页
const handleBack = () => {
  router.back()
}

onMounted(() => {
  fetchOrderInfo()
})
</script>

<style scoped>
.order-payment-page {
  max-width: 800px;
  margin: 0 auto;
}

.payment-card {
  border: 1px solid var(--app-border-subtle);
  border-radius: var(--app-radius-xl);
  box-shadow: var(--app-shadow-card);
  overflow: hidden;
  min-height: 400px;
}

.payment-content {
  padding: 24px;
}

.payment-layout {
  display: grid;
  grid-template-columns: 1fr 1.2fr;
  gap: 24px;
}

/* Summary header */
.summary-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 20px;
  padding-bottom: 14px;
  border-bottom: 1px solid var(--app-border-light);
}

.summary-header svg {
  color: var(--app-color-primary);
}

.section-title {
  font-size: 1.0625rem;
  font-weight: 600;
  color: var(--app-text-primary);
  margin: 0;
}

/* Order summary */
.order-summary {
  background: var(--app-bg-card);
  border-radius: var(--app-radius-xl);
  padding: 24px;
  border: 1px solid var(--app-border-subtle);
  box-shadow: var(--app-shadow-card);
}

.order-details {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.detail-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.detail-row .label {
  color: var(--app-text-secondary);
  font-weight: 500;
  font-size: 0.9375rem;
}

.detail-row .value {
  color: var(--app-text-primary);
  font-weight: 500;
  font-size: 0.9375rem;
}

.detail-row .value.mono {
  font-family: 'SF Mono', 'Courier New', monospace;
  font-size: 0.8125rem;
  color: var(--app-text-secondary);
}

.detail-divider {
  height: 1px;
  background: var(--app-border-light);
  margin: 4px 0;
}

.detail-row.pay-amount .label {
  font-size: 1rem;
}

.detail-row .value.price {
  font-size: 1.375rem;
  font-weight: 700;
  color: var(--app-color-primary);
}

/* Payment methods */
.payment-methods {
  background: var(--app-bg-card);
  border-radius: var(--app-radius-xl);
  padding: 24px;
  border: 1px solid var(--app-border-subtle);
  box-shadow: var(--app-shadow-card);
}

.method-options {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.method-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: var(--app-bg-soft);
  border: 2px solid var(--app-border-light);
  border-radius: var(--app-radius-lg);
  padding: 16px 18px;
  cursor: pointer;
  transition: all 0.25s ease;
}

.method-item:hover {
  border-color: var(--app-color-primary-light);
  background: var(--app-color-primary-muted);
}

.method-item.selected {
  border-color: var(--app-color-primary);
  background: var(--app-color-primary-soft);
}

.method-left {
  display: flex;
  align-items: center;
  gap: 14px;
}

.method-icon {
  width: 44px;
  height: 44px;
  border-radius: var(--app-radius-md);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: #fff;
}

.method-icon.alipay {
  background: linear-gradient(135deg, #1677ff, #4096ff);
}

.method-icon.wechat {
  background: linear-gradient(135deg, #07c160, #39d17a);
}

.method-info h3 {
  font-size: 0.9375rem;
  font-weight: 600;
  color: var(--app-text-primary);
  margin: 0 0 2px;
}

.method-info p {
  font-size: 0.8125rem;
  color: var(--app-text-secondary);
  margin: 0;
}

.method-selector {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  border: 2px solid var(--app-border-light);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.25s ease;
  flex-shrink: 0;
}

.method-selector.selected {
  background: var(--app-color-primary);
  border-color: var(--app-color-primary);
  color: #fff;
}

.method-selector svg {
  display: none;
}

.method-selector.selected svg {
  display: block;
}

/* Action bar */
.action-bar {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 16px;
  margin-top: 24px;
  padding-top: 20px;
  border-top: 1px solid var(--app-border-light);
}

.cancel-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 12px 24px !important;
  border-color: var(--app-border-light) !important;
  color: var(--app-text-secondary) !important;
  border-radius: var(--app-radius-lg) !important;
  font-weight: 500 !important;
}

.cancel-btn:hover {
  border-color: var(--app-color-primary) !important;
  color: var(--app-color-primary) !important;
}

.pay-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 12px 32px !important;
  font-size: 1rem !important;
  font-weight: 600 !important;
  border-radius: var(--app-radius-lg) !important;
  background: var(--app-gradient-primary) !important;
  border: none !important;
  box-shadow: 0 4px 15px rgba(255, 126, 126, 0.35) !important;
}

.pay-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(255, 126, 126, 0.5) !important;
}

.pay-btn:disabled {
  opacity: 0.5;
  box-shadow: none !important;
}

.error-message {
  color: #f56c6c;
  text-align: center;
  padding: 60px 20px;
  font-size: 0.9375rem;
}

@media (max-width: 768px) {
  .payment-layout {
    grid-template-columns: 1fr;
  }

  .action-bar {
    flex-direction: column;
  }

  .cancel-btn,
  .pay-btn {
    width: 100%;
    justify-content: center;
  }
}
</style>
